module.exports = __webpack_public_path__ + "img/GH-kyujin-top-pa004.956fc28b.webp";